import { defineMessages } from 'react-intl';

/** Streaming → Audience (design streaming-sections a1-a3, e2). */
export const audienceMessages = defineMessages({
  emptyTitle: { id: 'app.sml.streaming.audience.empty.title', defaultMessage: 'See who listens to you' },
  emptyText: {
    id: 'app.sml.streaming.audience.empty.text',
    defaultMessage:
      'Your connected sources do not report listener age and gender. Connect a source that does, and MUSIC24 shows the split by age and gender for each month.',
  },
  monthLine: {
    id: 'app.sml.streaming.audience.monthLine',
    defaultMessage: '{source} gives age and gender per month.',
  },
  monthShown: { id: 'app.sml.streaming.audience.monthShown', defaultMessage: 'Shown: {month}.' },
  gender: { id: 'app.sml.streaming.audience.gender', defaultMessage: 'Gender' },
  age: { id: 'app.sml.streaming.audience.age', defaultMessage: 'Age' },
  listeners: { id: 'app.sml.streaming.audience.listeners', defaultMessage: '{count} listeners' },
  genderFemale: { id: 'app.sml.streaming.audience.gender.female', defaultMessage: 'Female' },
  genderMale: { id: 'app.sml.streaming.audience.gender.male', defaultMessage: 'Male' },
  genderNonBinary: { id: 'app.sml.streaming.audience.gender.nonBinary', defaultMessage: 'Non-binary' },
  genderUnknown: { id: 'app.sml.streaming.audience.gender.unknown', defaultMessage: 'Not given' },
  stores: { id: 'app.sml.streaming.audience.stores', defaultMessage: 'Listeners by store' },
  storeColumn: { id: 'app.sml.streaming.audience.stores.store', defaultMessage: 'Store' },
  shareColumn: { id: 'app.sml.streaming.audience.stores.share', defaultMessage: 'Share' },
  listenersColumn: { id: 'app.sml.streaming.audience.stores.listeners', defaultMessage: 'Listeners' },
  changeColumn: { id: 'app.sml.streaming.audience.stores.change', defaultMessage: 'Change' },
  storesChangeNote: {
    id: 'app.sml.streaming.audience.stores.changeNote',
    defaultMessage: 'Change is against the month before.',
  },
  shareNote: {
    id: 'app.sml.streaming.audience.shareNote',
    defaultMessage: 'Share is of the listeners whose age or gender the store knows.',
  },
  noStoreSplit: {
    id: 'app.sml.streaming.audience.noStoreSplit',
    defaultMessage: '{source} is one store, so this source has no split by store.',
  },
  noWholeMonthText: {
    id: 'app.sml.streaming.audience.noWholeMonth.text',
    defaultMessage:
      '{source} gives listener age and gender once a month, so this period has no numbers. Pick 28 days or more, or see the newest month that {source} reported.',
  },
  noRowsTitle: {
    id: 'app.sml.streaming.audience.noRows.title',
    defaultMessage: '{source} has no age and gender numbers for {start} – {end}.',
  },
  errorTitle: { id: 'app.sml.streaming.audience.error', defaultMessage: 'We could not load your audience numbers' },
});
